import './PaperOrientation.less';

import classNames from 'classnames';
import { OrientationEnum } from 'domains/skuDomain';

export type PaperOrientationProps = {
  type: OrientationEnum;
};

export const PaperOrientation = (props: PaperOrientationProps) => {
  return (
    <div className={classNames('revx-paper-orientation', props.type)}>
      <div className={classNames('revx-paper-orientation-inner')}>A</div>
    </div>
  );
};
